export const PATH = {
  newTermConditionRequest: 'api/NewTermConditionRequest',
  updateTermConditionRequest: 'api/UpdateTermConditionRequest',
  getTermConditionListRequest: 'api/GetTermConditionListRequest',
  deleteTermConditionRequest: 'api/DeleteTermConditionRequest',
  completeTermsAndConditions: 'api/CompleteTermConditionRequest',
  checkTermsAndConditions: 'api/CheckTermsConditionReadyRequest',
}
